'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/sortable');

const Translator = require('./../../../../core/translator');
const PageRepository = require('./../../../../bundles/page/repository/page');
const Autocomplete = require('./../../../autocomplete');
const Loader = require('./../../../loader');
const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');
let itemTpl = require('./template/item.hbs');

FormBuilder.register('searchPageType', function(config) {
  let self = {};
  let $itemWrapper;
  let autocompleteConfig = {
    autocomplete: {
      'source': function(request, response) {
        let $element = config.form.$.find(`.element_${config.name}`);
        let $input = $element.find('.input-autocomplete');

        $input.find('span:first').addClass('invisible');

        Loader.start($input);

        PageRepository.get({
          'title': '%' + request.term + '%',
        }).done(function(data) {
          $input.find('span:first').removeClass('invisible');
          Loader.stop($input);

          if (data.length > 0) {
            response(jQuery.map(data, function(item) {
              return {
                label: (item.lang ? `${item.lang.toUpperCase()} - ` : '') + `${item.title}`,
                value: item.url,
                id: item.id,
                url: item.url,
              };
            }));
          } else {
            $element.find('ul.ui-autocomplete').empty();
          }
        });
      },
      'select': function(event, object) {
        jQuery(event.target).val('');
        self.addItem(object.item);

        return false;
      },
    },
  };

  self = new ElementClass(config);

  self.addItem = function(data) {
    let $item = jQuery(itemTpl());
    let $inputBtn = $item.find('span.btn');
    let $remove = $item.find('button.remove');

    if (data) {
      $inputBtn.find('.cloud-label').text(data.label);
      $inputBtn.data('id', data.id);
    }

    $remove.on('click', function() {
      $item.remove();
    });

    $itemWrapper.append($item);
  };

  self.render = function($wrap) {
    let $autocompleteInput = Autocomplete.render(autocompleteConfig);

    $wrap.addClass('cloud-menu-parameters');

    $itemWrapper = jQuery('<ul class="menu-item-wrapper cloud-list list-unstyled "></ul>');

    $itemWrapper.sortable();

    if (config.value.id) {
      self.addItem({'id': config.value.id, 'label': config.value.title});
    } else {
      _.forEach(config.value, function(item) {
        self.addItem(item);
      });
    }

    $wrap.append('<label class="cloud-label">' + Translator.translate('search_page_type_form_explanation') + '</label>');
    $wrap.append($autocompleteInput);
    $wrap.append('<div class="cloud-divider"></div>');
    $wrap.append($itemWrapper);
  };

  self.getData = function() {
    let data = [];

    $itemWrapper.find('.item').each(function() {
      let $current = jQuery(this);
      let $inputBtn = $current.find('span.btn');

      data.push({
        'id': $inputBtn.data('id'),
        'label': $inputBtn.find('.cloud-label').text(),
      });
    });

    return data;
  };

  return self;
});
